<template>
  <v-form
    ref="form"
    lazy-validation
    class="app-form pt-1"
    @submit.prevent="onSubmit"
  >
    <v-row>
      <v-col
        cols="12"
        lg="6"
        md="6"
        sm="12"
      >
        <v-text-field
          v-model="form.nome"
          placeholder="Digite o nome"
          label="Nome *"
          :rules="[rules.required]"
          dense
          outlined
        />
      </v-col>
      <v-col
        cols="12"
        lg="6"
        md="6"
        sm="12"
      >
        <v-text-field
          v-model="form.cpf"
          v-mask="'###.###.###-##'"
          placeholder="Digite o cpf"
          label="CPF *"
          :rules="[rules.required, rules.cpf]"
          dense
          outlined
        />
      </v-col>
      <v-col
        cols="12"
        lg="6"
        md="6"
        sm="12"
      >
        <v-text-field
          v-model="form.celular"
          v-mask="'(##)#####-####'"
          placeholder="Digite o celular"
          label="Celular *"
          :rules="[rules.required, rules.cellphone]"
          dense
          outlined
        />
      </v-col>
      <v-col
        cols="12"
        lg="6"
        md="6"
        sm="12"
      >
        <v-text-field
          v-model="form.telefone"
          v-mask="'(##)####-####'"
          placeholder="Digite o telefone"
          label="Telefone"
          :rules="[rules.phone]"
          dense
          outlined
        />
      </v-col>
      <v-col
        cols="12"
        lg="12"
        md="12"
        sm="12"
      >
        <v-text-field
          v-model="form.email"
          placeholder="Digite o email"
          label="E-mail*"
          :rules="[rules.required, rules.email]"
          dense
          outlined
        />
      </v-col>
    </v-row>
    <v-divider />
    <v-card-actions class="mr-0 ml-0 pt-0 pb-0 pr-0">
      <v-spacer />
      <v-btn
        depressed
        type="submit"
        color="primary"
        class="mt-3"
      >
        Continuar
      </v-btn>
    </v-card-actions>
    <section
      v-if="form.isLoading"
      class="loading"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
      <span>Enviando informações ...</span>
    </section>
  </v-form>
</template>

<script>
import VeiculoTransportadoraService from "@/services/sit-pedidos/veiculo-transportadora.service";

// Vuex Store - Sit Pedidos (mapping actions and states)
import { mapActions, mapMutations, mapState } from "vuex";
import pedidoService from '@/services/sit-pedidos/pedido.service';
const actions = mapActions('sitPedidos', ['setFormPedidoContact', 'setFormIsLoading', 'setFormStep'])
const state = mapState('global', ['snackbar'])


import { validateCpf } from "@/helpers/cpf.validator";

export default {
  name: "FormContact",

  data: () => ({
    isLoadingSearch: false,

    search: null,

    items: [],

    form: {
      nome: "",
      cpf: "",
      email: "",
      celular: "",
      telefone: ""
    },

    rules: {
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "E-mail inválido.";
      },
      cellphone: value => {
        const pattern = /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)(?:((?:9\d|[2-9])\d{3})-?(\d{4}))$/
        return pattern.test(value) || "Celular inválido.";
      },
      phone: value => {
        if(!value) return true

        const pattern = /(\(?\d{2}\)?\s)?(\d{4}-\d{4})$/
        return pattern.test(value) || "Telefone inválido.";
      },
      cpf: value => !!validateCpf(value) || "CPF inválido",
      required: value => {
        if(!value) return true;

        return !!value.replaceAll(/\s/g,'') || "Esse campo deve ser preenchido"
      },
    }
  }),

  computed: {
    ...state,
  },

  methods: {
    ...actions,

    onSubmit() {
      const isValid = this.$refs.form.validate();

      if (isValid) {
        this.setFormIsLoading(true)

        pedidoService.createShippingCompanyContact(this.form).subscribe((res)=>{
          this.setFormIsLoading(false)
          this.setFormPedidoContact(this.form)
          this.setFormStep(2)
          this.resetForm()
        }, (err)=>{
          this.setFormIsLoading(false)
        })
      }
    },

    resetForm() {
      this.form = {
        nome: "",
        cpf: "",
        email: "",
        celular: "",
        telefone: ""
      }

      this.$refs.form.reset()
    },
  },
};
</script>

